/* eslint-disable no-undef */
import React, { Component, useState, useEffect } from "react";
import { Trans, withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import axios from "axios";
import subscribe from "../../auth/subscribe";
import FloatingAlert from "../../components/FloatingAlert/FloatingAlert";
import bgSliders from "../../helpers/bgSliders";
import { setAgencyData, logtracker, saveTracker } from "../../helpers/agencyTracker";
import "./indonesiaSignupPage.scss";
import * as localLang from "../../i18n/i18n";
import IndonesiaSignupPageDisplay from "./indonesiaSignupPage.styled";

import { getPhoneByHeader } from "./services"
import { isMobile } from 'react-device-detect';
import Modal from "react-modal";
import { useHistory } from 'react-router-dom';

function IndonesiaSignupPage({ t }) {
  const history = useHistory();
  const [keyword, setKeyword] = useState("");
  const [showLoading, setshowLoading] = useState(false);
  const [errorMesg, setErrorMesg] = useState(false);
  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const funzoneOptions = [
    {
      label: " Rp 2.220 / 3 day (Included VAT)",
      value: "REG FUNZONE1"
    },
    {
      label: " Rp 3.330 / 3 day (Included VAT)",
      value: "REG FUNZONE2"
    },
    {
      label: "Rp 5.550 / 7 day (Included VAT)",
      value: "REG FUNZONE3"
    },
    {
      label: "Rp 11.100 / 14 day (Included VAT)",
      value: "REG FUNZONE4"
    },
    {
      label: "Rp 16.650 / 30 day (Included VAT)",
      value: "REG FUNZONE5"
    }
  ];



  useEffect(() => {
   
    const urlsearch = window.location.search;

    if (urlsearch !== "") {
      setAgencyData(urlsearch);
    }


  }, [])
  const signup = async () => {
    if (!keyword) {
      setErrorMesg(true);
      setErrorMesgSubscribe("Please select a subscription plan");
      return;
    }
    const company = localStorage.getItem("trackerCompany") ? localStorage.getItem("trackerCompany") : "";
    const key = localStorage.getItem("tracker") ? localStorage.getItem("tracker") : "";
    try {
      await axios.post(
        `https://vas2.grand-hub.com/api/playIt/telkomsel-in/he`,
        { keyword: keyword ,
          company: company,
          key: key
        }
      ).then(res => {
        if (res.data.url) {
          window.location.href = res.data.url;
        } else {
          setErrorMesg(true);
          setErrorMesgSubscribe(res.data.message);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <IndonesiaSignupPageDisplay >

      {errorMesg ? (
        <FloatingAlert type={"error"}>
          <Trans>{errorMesgSubscribe}</Trans>
        </FloatingAlert>
      ) : null}

      {showLoading ?
        <div className="load">
          <div className="spinerC">
            <div className="spinner"></div>
          </div>
        </div>
        : null}


      <div className='operatorSignup'>
        <div className="formsLayout formsLayoutjawal">

          <div className='header header_gamezone'>
                       <Link to="/">
                         <div className='logo  gamezoneLogo '  alt="service logo" />
                       </Link>
                     </div>

            
              
            <div className="links-Section links-SectionGamezorid">
                            <div className="play"></div>
<div className="main_span ">
 <p > <Trans>Playit offers more than 500 games for game lovers</Trans></p>
  </div>

               
                <div className="d-flex justify-content-center">
 <select
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              className="keyword-dropdown text-center form-control"
            >
              <option value="" disabled>
                Select Subscription Plan
              </option>

              {funzoneOptions.map((option) => (
                <option key={option.value} value={option.value} className="text-center">
                  {option.label}
                </option>
              ))}
            </select>
                </div>
             
          

              <div className="normBtn">
                <div className="d-flex justify-content-center">
                  <button
                    className="btn AFsubmitbtn"
                    type="button"
                  
                    onClick={signup}
                  >
                    <Trans>asiacellSubscribe.subscribe</Trans>
                  </button>
                </div>
              </div>
           
            </div>
            <div className="footer">

              <p>
                <Trans>accept_subscribe</Trans>{" "}
                <Link to="tos">
                  <Trans>terms_and_conditions</Trans>
                </Link>
              </p>

            </div>


          </div>
      </div>
    </IndonesiaSignupPageDisplay>
  );

}
export default withTranslation()(IndonesiaSignupPage);
